import Vue from 'vue';
import Router, { RouteConfig } from 'vue-router';
import Layout from '@/views/layout/Layout.vue';

Vue.use(Router);


/*
  redirect:                      if `redirect: noredirect`, it won't redirect if click on the breadcrumb
  meta: {
    title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    breadcrumb: false            if false, the item will be hidden in breadcrumb (default is true)
    hidden: true                 if true, this route will not show in the sidebar (default is false)
  }
*/
export const constantRoutes: RouteConfig[] = [
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
    meta: { hidden: true },
  },
  {
    path: '/forgetPassword',
    component: () => import(/* webpackChunkName: "forgetPassword" */ '@/views/login/forgetPassword.vue'),
    meta: { hidden: true },
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
    meta: { hidden: true },
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    name: 'Dashboard',
    meta: { title: 'Dashboard', icon: 'people' },
    children: [{
      path: 'dashboard',
      component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/index.vue'),
    }],
  },
  // {
  //   path: '*',
  //   redirect: '/404',
  //   meta: { hidden: true },
  // },
];

// 需要动态加载的路由器 要经过权限的筛选
export const asyncRoutes: RouteConfig[] = [
  {
    path: '/userProfile',
    component: Layout,
    redirect: '/userProfile/info',
    name: 'userProfile',
    meta: { title: 'UserProfile', icon: 'example' },
    children: [
      {
        path: 'info',
        name: 'info',
        component: () => import(/* webpackChunkName: "table" */ '@/views/admin/userInfo.vue'),
        meta: { title: 'AccountInfo', icon: 'table' },
      },
      {
        path: 'updatepassword',
        name: 'updatepassword',
        component: () => import(/* webpackChunkName: "tree" */ '@/views/admin/password.vue'),
        meta: { title: 'UpdatePassword', icon: 'tree' },
      },
      {
        path: 'userSetting',
        name: 'userSetting',
        component: () => import(/* webpackChunkName: "table" */ '@/views/admin/setting.vue'),
        meta: { title: 'UserSetting', icon: 'table' },
      },
      {
        path: 'about',
        name: 'about',
        component: () => import(/* webpackChunkName: "table" */ '@/views/admin/about.vue'),
        meta: { title: 'About', icon: 'table' },
      },
    ],
  },
  {
    path: '/admin',
    component: Layout,
    redirect: '/admin/list',
    name: 'admin',
    meta: {
      title: 'AdminManagement',
      icon: 'eye-on',
      alwaysShow: true, // will always show the root menu
      roles: ['admin', 'editor'], // you can set roles in root nav
    },
    children: [
      {
        path: 'list',
        name: 'list',
        component: () => import(/* webpackChunkName: "tree" */ '@/views/admin/list.vue'),
        meta: { title: 'AccountList', icon: 'tree' },
      },
      {
        path: 'addAdmin',
        component: () => import('@/views/admin/addAdmin.vue'),
        name: 'addAdmin',
        meta: {
          title: 'AddAdmin',
          roles: ['admin'],
          icon: 'link',
        },
      },
      {
        path: 'FrontRole',
        component: () => import('@/views/permission/frontRole.vue'),
        name: 'RoleFrontPermission',
        meta: {
          title: 'RoleFrontPermission',
          roles: ['admin'],
          icon: 'link',
        },
      },

      // {
      //   path: 'BackendRole',
      //   component: () => import('@/views/permission/backendRole.vue'),
      //   name: 'RoleBackPermission',
      //   meta: {
      //     title: 'RoleBackPermission',
      //     roles: ['admin'],
      //     icon: 'link',
      //   },
      // },

      {
        path: 'companys',
        component: () => import('@/views/admin/companys.vue'),
        name: 'companys',
        meta: {
          title: 'CompanyList',
          roles: ['admin'],
          icon: 'link',
        },
      },
      {
        path: 'addCompany',
        component: () => import('@/views/admin/addCompany.vue'),
        name: 'addCompany',
        meta: {
          title: 'AddCompany',
          roles: ['admin'],
          icon: 'link',
        },
      },
      {
        path: 'operate',
        name: 'operate',
        component: () => import(/* webpackChunkName: "table" */ '@/views/setting/operate.vue'),
        meta: { title: 'Operate', icon: 'table' },
      },
    ],
  },
  {
    path: '/system',
    component: Layout,
    redirect: '/account/CostsSet',
    name: 'system',
    meta: { title: 'SystemManagement', icon: 'example' },
    children: [
      {
        path: 'Holiday',
        name: 'Holiday',
        component: () => import(/* webpackChunkName: "table" */ '@/views/system/holiday.vue'),
        meta: { title: 'Holiday', icon: 'table' },
      },
      {
        path: 'AddHoliday',
        name: 'AddHoliday',
        component: () => import(/* webpackChunkName: "table" */ '@/views/system/addHoliday.vue'),
        meta: { title: 'AddHoliday', icon: 'table' },
      },
      {
        path: 'CostsSet',
        name: 'CostsSet',
        component: () => import(/* webpackChunkName: "table" */ '@/views/system/costset.vue'),
        meta: { title: 'CostsSet', icon: 'table' },
      },
      {
        path: 'AddCostSet',
        name: 'AddCostSet',
        component: () => import(/* webpackChunkName: "table" */ '@/views/system/addCostset.vue'),
        meta: { title: 'AddCostSet', icon: 'table' },
      },
      // {
      //   path: 'message',
      //   name: 'message',
      //   component: () => import(/* webpackChunkName: "table" */ '@/views/system/message.vue'),
      //   meta: { title: 'Message', icon: 'table' },
      // },
    ],
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/list',
    name: 'user',
    meta: { title: 'UserManager', icon: 'example', alwaysShow: true }, // will always show the root menu },
    children: [
      {
        path: 'list',
        name: 'list',
        component: () => import(/* webpackChunkName: "table" */ '@/views/user/list.vue'),
        meta: { title: 'UserList', icon: 'table' },
      },
      {
        path: 'addUser',
        name: 'addUser',
        component: () => import(/* webpackChunkName: "table" */ '@/views/user/addUser.vue'),
        meta: { title: 'AddUser', icon: 'table' },
      },
      {
        path: 'installerUsers',
        name: 'installerUsers',
        component: () => import(/* webpackChunkName: "table" */ '@/views/user/installerList.vue'),
        meta: { title: 'InstallerUser', icon: 'table' },
      },
      {
        path: 'addInstallUser',
        name: 'addInstallUser',
        component: () => import(/* webpackChunkName: "table" */ '@/views/user/addInstallUser.vue'),
        meta: { title: 'AddInstallUser', icon: 'table' },
      },
      // {
      //   path: 'userBill',
      //   name: 'userBill',
      //   component: () => import(/* webpackChunkName: "table" */ '@/views/user/bill.vue'),
      //   meta: { title: 'UserBill', icon: 'table' },
      // },
    ],
  },
  {
    path: '/meter',
    component: Layout,
    redirect: '/meter/list',
    name: 'meter',
    meta: { title: 'MeterManager', icon: 'example', alwaysShow: true }, // will always show the root menu },
    children: [
      {
        path: 'list',
        name: 'list',
        component: () => import(/* webpackChunkName: "table" */ '@/views/meter/list.vue'),
        meta: { title: 'MeterList', icon: 'table' },
      },
      {
        path: 'addMeter',
        name: 'addMeter',
        component: () => import(/* webpackChunkName: "table" */ '@/views/meter/addMeter.vue'),
        meta: { title: 'AddMeter', icon: 'table' },
      },
      {
        path: 'meterAnalyze',
        name: 'meterAnalyze',
        component: () => import(/* webpackChunkName: "table" */ '@/views/dashboard/analyze.vue'),
        meta: { title: 'MeterAnalyze', icon: 'table' },
      },
      {
        path: 'malfunction',
        name: 'malfunction',
        component: () => import(/* webpackChunkName: "table" */ '@/views/meter/malfunction.vue'),
        meta: { title: 'MalfunctionList', icon: 'table' },
      },
      {
        path: 'leakage',
        name: 'leakage',
        component: () => import(/* webpackChunkName: "table" */ '@/views/meter/leakage.vue'),
        meta: { title: 'LeakageList', icon: 'table' },
      },
      {
        path: 'order',
        name: 'order',
        component: () => import(/* webpackChunkName: "table" */ '@/views/meter/order.vue'),
        meta: { title: 'OrderList', icon: 'table' },
      },
      {
        path: 'network',
        name: 'network',
        component: () => import(/* webpackChunkName: "table" */ '@/views/meter/network.vue'),
        meta: { title: 'Network', icon: 'table' },
      },
      {
        path: 'addRsnetwork',
        name: 'addRsnetwork',
        component: () => import(/* webpackChunkName: "table" */ '@/views/meter/addRsNetwork.vue'),
        meta: { title: 'AddRsNetwork', icon: 'table' },
      },
      {
        path: 'rsnetwork',
        name: 'rsnetwork',
        component: () => import(/* webpackChunkName: "table" */ '@/views/meter/rsNetwork.vue'),
        meta: { title: 'RsNetwork', icon: 'table' },
      },
      {
        path: 'devices',
        name: 'devices',
        component: () => import(/* webpackChunkName: "table" */ '@/views/meter/devices.vue'),
        meta: { title: 'Devices', icon: 'table' },
      },
      {
        path: 'deviceControl',
        name: 'deviceControl',
        component: () => import(/* webpackChunkName: "table" */ '@/views/meter/deviceControl.vue'),
        meta: { title: 'DeviceControl', icon: 'table' },
      },
      {
        path: 'deviceSchedule',
        name: 'deviceSchedule',
        component: () => import(/* webpackChunkName: "table" */ '@/views/meter/deviceSchedule.vue'),
        meta: { title: 'DeviceSchedule', icon: 'table' },
      },
      {
        path: 'meterFirewareList',
        name: 'meterFirewareList',
        component: () => import(/* webpackChunkName: "table" */ '@/views/meter/meterFirewareList.vue'),
        meta: { title: 'MeterFirewareList', icon: 'table' },
      },
      {
        path: 'firewareList',
        name: 'firewareList',
        component: () => import(/* webpackChunkName: "table" */ '@/views/meter/firewareList.vue'),
        meta: { title: 'FirewareList', icon: 'table' },
      },
      {
        path: 'addFireware',
        name: 'addFireware',
        component: () => import(/* webpackChunkName: "table" */ '@/views/meter/addFireware.vue'),
        meta: { title: 'AddFireware', icon: 'table' },
      },
    ],
  },

];
export default new Router({
  mode: 'history',  // Disabled due to Github Pages doesn't support this, enable this if you need.
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  base: process.env.BASE_URL,
  routes: constantRoutes,
});
